<template>
  <div :class="[iphoneX?'iphoneX':'goldFree']">
    <c-nav></c-nav>
    <div class="container">
      <div class="rule" @click="gotoRule">活动规则</div>
      <div class="priority">
        <div class="title">五大会员专属特权</div>
        <div class="content">
          <div class="birthday fx fx-c-center">
            <div class="icon"></div>
            <div class="desc"><span class="red">29元</span>生日礼物</div>
          </div>
          <div class="hotel fx fx-c-center">
            <div class="icon"></div>
            <div class="desc">酒店专享<span class="red">9.4折</span></div>
          </div>
          <div class="speedup fx fx-c-center">
            <div class="icon"></div>
            <div class="desc">抢票提速<span class="red">1.5倍</span></div>
          </div>
          <div class="tisubao fx fx-c-center">
            <div class="icon"></div>
            <div class="desc">提速宝<span class="red">10个</span></div>
          </div>
          <div class="delayTreture fx fx-c-center">
            <div class="icon"></div>
            <div class="desc">延误宝<span class="red">2个</span></div>
          </div>
        </div>
      </div>
    </div>
    <rule :isShowRule='isShowRule' @close='close'></rule>
    <bottom-button text='免费领取黄金会员' @getVIP='getVIP'></bottom-button>
  </div>
</template>
<script>
  import bottomButton from './components/bottomButton'
  import rule from './components/rule.vue'

  import auth from "@/request/auth.js";
  import {
    handleException
  } from "@/request/helpers.js";
  import localStorage from "@/utils/localStorage.js";
  import ga from '@/utils/tracker.js'

  import {
    mapActions
  } from 'vuex'

  export default {
    data() {
      return {
        iphoneX: false,
        isShowRule: false
      }
    },
    mounted() {
      this.$updateTitle('会员新福利');
      this.shareWeChat();
    },
    methods: {
      ...mapActions('vipCard/goldFree', ['creatGlodVIP']),
      shareWeChat() {
        var shareHtml, shareScript;

    //       shareHtml
    //        = '<div style="display:none;">'
    //          + '<div id="fenxiang_title">' + shareConfig.title + '</div>'
    //          + '<div id="fenxiang_img">'   + shareConfig.img   + '</div>'
    //          + '<div id="fenxiang_desc">'  + shareConfig.desc  + '</div>'
    //          + '<div id="fenxiang_link">'  + shareConfig.link  + '</div>'
    //       + '</div>';

        
        shareHtml = document.createElement('div');
        shareHtml.setAttribute('style','display:none;');

        var title = document.createElement('div');
        title.setAttribute('id','fenxiang_title');
        var title_text = document.createTextNode('高铁管家黄金会员权益免费领');
        title.appendChild(title_text);
        shareHtml.appendChild(title);

        var img = document.createElement('div');
        img.setAttribute('id','fenxiang_img');
        var img_content = document.createTextNode('https://cdn.133.cn/gtgj/web/goldFree/shareGold.png');
        img.appendChild(img_content);
        shareHtml.appendChild(img);

        var desc = document.createElement('id','fenxiang_desc');
        desc.setAttribute('id','fenxiang_desc');
        var desc_content = document.createTextNode('五大专享会员权益，出行更省心~');
        desc.appendChild(desc_content);
        shareHtml.appendChild(desc);

        shareHtml.appendChild(desc);

        var link = document.createElement('div');
        link.setAttribute('id','fenxiang_link');
        var link_content = document.createTextNode('https://h5.133.cn/gtgjwap/h5/vipCard/goldFree');
        link.appendChild(link_content);
        shareHtml.appendChild(link);

        document.body.appendChild(shareHtml);


        // shareScript
        //   = '<script ' +
        //   'data-main="//jp.rsscc.com/promotion/scripts/wechattools/main" ' +
        //   'src="//jp.rsscc.com/promotion/scripts/wechattools/require.js">' +
        //   '&lt;/script>';

        shareScript = document.createElement('script');

        shareScript.setAttribute(
          'data-main', '//jp.rsscc.com/promotion/scripts/wechattools/main'
        );

        shareScript.src = '//jp.rsscc.com/promotion/scripts/wechattools/require.js';

        document.body.appendChild(shareScript);

      },
      gotoRule() {
        this.isShowRule = true;
      },
      close() {
        this.isShowRule = false;
      },
      isIphoneX() {
        return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
      },
      getVIP() {
        ga.track('goldFree', 'clickOpenVIP', 'browser');
        auth.ensure({
          rp: {
            path: '/vipCard/vipPriority'
          }
        }).then(() => {
          let user = localStorage.get("user");
          if (user && user.phone) {
            // this.createOrder();
            this.creatGlodVIP().then((res) => {
              let code = parseInt(res.res.bd.data.code);
              if (code === 0) {
                this.$router.push({
                  path: '/vipCard/vipPriority'
                })
              } else if (code === 3) {
                return this.$notify({
                  type: "info",
                  message: "您已经领取过啦",
                  showClose: true
                });
              }
            }).catch((err) => {
              handleException.call(this, err, true);
            })
          }
        }).catch((err) => {
          this.$notify({
            type: "error",
            message: (err && err.msg) || "登录失败，请稍后再试",
            showClose: true
          });
        });
      }
    },
    created() {
      // console.log(navigator.userAgent, 8888);
      this.iphoneX = this.isIphoneX();
      // console.log(this.iphoneX);
    },
    components: {
      bottomButton,
      rule
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/scss/_vars.scss';
  @import './style/common.scss';
  .red {
    color: #f43b41;
  }
  .goldFree {
    width: 100%;
    height: 100%;
    .container {
      width: 100%;
      // height: 100%;
      height: 603*$px;
      position: relative;
      @include bg('bg1@3x.png');
      .rule {
        position: absolute;
        right: 0;
        top: 16*$px;
        width: 65*$px;
        background-color: rgba(0, 73, 219, 0.3);
        color: rgba(255, 255, 255, 0.68);
        text-align: center;
        font-size: 12*$px;
        height: 21*$px;
        line-height: 21*$px;
        border-top-left-radius: 10*$px;
        border-bottom-left-radius: 10*$px;
      }
      .priority {
        box-sizing: border-box;
        position: absolute;
        left: 118*$px;
        top: 253*$px;
        height: 345*$px;
        width: 202*$px;
        .title {
          height: 56*$px;
          line-height: 56*$px;
          font-size: 17*$px;
          margin-top: 13*$px;
          text-align: center;
          color: #fff;
          position: relative;
          &::before {
            display: block;
            height: 12*$px;
            width: 12*$px;
            content: '';
            @include bg('star@3x.png');
            position: absolute;
            left: 12*$px;
            top: 20*$px;
          }
          &::after {
            display: block;
            height: 12*$px;
            width: 12*$px;
            content: '';
            @include bg('star@3x.png');
            position: absolute;
            right: 12*$px;
            top: 20*$px;
          }
        }
        .content {
          height: 250*$px;
          padding-left: 32*$px;
          padding-top: 19*$px;
          .birthday,
          .hotel,
          .speedup,
          .tisubao,
          .delayTreture {
            font-size: 13*$px;
            margin-bottom: 7*$px;
            .icon {
              width: 30*$px;
              height: 30*$px;
              margin-right: 16*$px;
              @include bg('1@3x.png');
            }
            .desc {
              margin-top: 2*$px;
            }
          }
          .hotel {
            .icon {
              @include bg('2@3x.png')
            }
          }
          .speedup {
            .icon {
              @include bg('3@3x.png')
            }
          }
          .tisubao {
            .icon {
              @include bg('4@3x.png')
            }
          }
          .delayTreture {
            .icon {
              @include bg('5@3x.png')
            }
          }
        }
      }
    }
  }
  .iphoneX {
    width: 100%;
    height: 100%;
    background-color: #161439;
    .container {
      width: 100%;
      // height: 100%;
      height: 748*$px;
      position: relative;
      @include bg('bg1_iphonex@3x.png');
      .rule {
        position: absolute;
        right: 0;
        top: 16*$px;
        width: 65*$px;
        background-color: rgba(0, 73, 219, 0.3);
        color: rgba(255, 255, 255, 0.68);
        text-align: center;
        font-size: 12*$px;
        height: 21*$px;
        line-height: 21*$px;
        border-top-left-radius: 10*$px;
        border-bottom-left-radius: 10*$px;
      }
      .priority {
        box-sizing: border-box;
        // padding-left: 32*$px;
        //   padding-top: 100*$px;
        position: absolute;
        left: 118*$px;
        top: 323*$px;
        height: 345*$px;
        width: 202*$px;
        .title {
          height: 76*$px;
          line-height: 56*$px;
          font-size: 17*$px;
          margin-top: 13*$px;
          text-align: center;
          color: #fff;
          position: relative;
          &::before {
            display: block;
            height: 12*$px;
            width: 12*$px;
            content: '';
            @include bg('star@3x.png');
            position: absolute;
            left: 12*$px;
            top: 20*$px;
          }
          &::after {
            display: block;
            height: 12*$px;
            width: 12*$px;
            content: '';
            @include bg('star@3x.png');
            position: absolute;
            right: 12*$px;
            top: 20*$px;
          }
        }
        .content {
          height: 250*$px;
          padding-left: 32*$px;
          padding-top: 19*$px;
          .birthday,
          .hotel,
          .speedup,
          .tisubao,
          .delayTreture {
            font-size: 13*$px;
            margin-bottom: 12*$px;
            .icon {
              width: 30*$px;
              height: 30*$px;
              margin-right: 16*$px;
              @include bg('1@3x.png');
            }
            .desc {
              margin-top: 2*$px;
            }
          }
          .hotel {
            .icon {
              @include bg('2@3x.png')
            }
          }
          .speedup {
            .icon {
              @include bg('3@3x.png')
            }
          }
          .tisubao {
            .icon {
              @include bg('4@3x.png')
            }
          }
          .delayTreture {
            .icon {
              @include bg('5@3x.png')
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/projects/vipCard/pages/goldFree/index.vue